import React, { Component } from 'react';
import {Row,Col,Form} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2'; 

import {MSG_REQUIRED} from '../../../configs/msgConfigs';
import {LBL_MUTE_NOTICATIONS,LBL_MUTE_EMAILS,LBL_SEND_VERIFI_EMAIL,LBL_PRIMARY_CONTACT, LBL_SELECT_CONTACT, LBL_FIRST_NAME, LBL_LAST_NAME, LBL_CONTACT_NUMBER, LBL_EMAIL_ADDRESS, LBL_RESEND_VERIFI_EMAIL, LBL_POSITION, LBL_SAVE} from '../../../configs/labelConfigs';
import {PHONE_ISD_CODE, PHONE_ISD_NUM} from '../../../configs/staticConfigs';

class PrimaryContact extends Component {

    render(){
        const { clientData, isPrmCnctList, formErrors,users,isSuperAdmin,} = this.props;  /*isPrimaryContactSuccess*/ 
        let companyName = ''; 
        if(this.props.hasOwnProperty('showNameInHeader')) companyName = this.props.showNameInHeader;
        let dataDisabled = clientData.primaryContact.emailAddress && clientData.primaryContact.emailAddress.length && isPrmCnctList; 
        
        return(
            <div className="form-group col-md-12">
                <Form onSubmit={e => this.props.saveFormData(e)} >
                    <div className="box margin-top-12">
                        {/*<div className="tab-head">
                             <h6>{LBL_PRIMARY_CONTACT} {(companyName) && <span>{' - '+companyName}</span>} </h6> 
                        </div> */}
                        {/* <div>{'isPrmCnctList: '+JSON.stringify(isPrmCnctList)}</div> */}
                        <div className="box-content">
                            {isPrmCnctList && users.length>0 ? (
                                    <Row>
                                        <Col md={6}>
                                            <label>{LBL_SELECT_CONTACT}</label>
                                            <div className="form-group select-input">
                                                <select name="prmyCnctAssUserId" value={clientData.primaryContact.prmyCnctAssUserId || ''} onChange={e => this.props.onSelectPrmyUser(e)} tabIndex="1">
                                                    {users.map((item) => <option key={item.associate_id} value={item.associate_id}>{item.first_name+' '+item.last_name}</option>)}  
                                                </select>
                                            </div>                                
                                        </Col>
                                    </Row>
                                ) : (
                                    <React.Fragment></React.Fragment>
                                )}                                               
                            <Row>   
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_FIRST_NAME}</label>
                                        <div className="text-input"><input disabled={isPrmCnctList} type="text" name="firstName" onChange={this.props.onHandleChange} className={formErrors.firstName.length >0 ? "input-error" : ''} value={clientData.primaryContact.firstName || ''} tabIndex="2" /></div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_LAST_NAME}</label>
                                        <div className="text-input"><input disabled={isPrmCnctList} type="text" className={formErrors.lastName.length >0 ? "input-error" : ''} onChange={this.props.onHandleChange} name="lastName" value={clientData.primaryContact.lastName || ''} tabIndex="3"/></div>
                                    </div>
                                </Col>
                            </Row>
                            <Row> 
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_CONTACT_NUMBER}</label>
                                        <div className={formErrors.contactNumber.length >0 ? "input-error" : ''}>                                       
                                            <PhoneInput 
                                              country={PHONE_ISD_CODE}
                                              inputProps={{
                                                name: 'contactNumber',
                                                tabIndex: "4"
                                              }}
                                              value={clientData.primaryContact.contactNumber || PHONE_ISD_NUM} 
                                              onChange={this.props.onContactInputChange} 
                                              disabled={isPrmCnctList}
                                            />
                                        </div>
                                    </div>
                                </Col> 
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_EMAIL_ADDRESS}</label>
                                        <div className="input email-input"><input disabled={isPrmCnctList} type="email" className={formErrors.emailAddress.length >0 ? "input-error" : ''} onChange={this.props.onHandleChange} name="emailAddress" value={clientData.primaryContact.emailAddress || ''} tabIndex="5" />
                                        {formErrors.emailAddress.length >0 && formErrors.emailAddress!==MSG_REQUIRED && (
                                            <div className="text-red left-align text-12">{formErrors.emailAddress}</div>
                                        )} 
                                        <small className="text-red">{clientData.primaryContact.emailVerify===false&&clientData.primaryContact.emailAddress?'Not Verified':''}</small>
                                        <Link className={clientData.primaryContact.emailVerify===false&&clientData.primaryContact.emailAddress?'resend-btn float-right':'hide'} to="#" onClick={e => this.props.resendEmail(clientData.primaryContact.prmyCnctUserId)}>{LBL_RESEND_VERIFI_EMAIL}</Link>
                                        </div>
                                    </div>
                                </Col>
                            </Row> 
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_POSITION}</label>
                                        <div className="input-input"><input disabled={isPrmCnctList} type="text" onChange={this.props.onHandleChange} name="position" value={clientData.primaryContact.position || ''} tabIndex="6"/></div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="checkbox-wrapper conct-detailss form-group">
                                        <p>  </p>
                                        <p>  </p>
                                      <div className="custom-checkbox i-margin-top"><input type="checkbox" id="muteMails" name="muteMails" onChange={this.props.onHandleChange} checked={clientData.primaryContact.muteMails ? clientData.primaryContact.muteMails : false}/><label className="checkbox" htmlFor="muteMails"></label><label className="labeltext" htmlFor="muteMails">{LBL_MUTE_EMAILS}</label></div>

                                      <div className="custom-checkbox i-margin-top"><input type="checkbox" id="mutePushs" name="mutePushs" onChange={this.props.onHandleChange} checked={clientData.primaryContact.mutePushs ? clientData.primaryContact.mutePushs : false}/><label className="checkbox" htmlFor="mutePushs"></label><label className="labeltext" htmlFor="mutePushs">{LBL_MUTE_NOTICATIONS}</label></div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                {!this.props.primaryContactEmailAddress && <Col md={6}>
                                    <div className="form-group paddingTop35">
                                            <div className="custom-checkbox">
                                                <input type="checkbox" id="chkSendVerifyEmail" name="chkSendVerifyEmail"  onChange={this.props.onHandleChange} checked={clientData.primaryContact.chkSendVerifyEmail} value={clientData.primaryContact.chkSendVerifyEmail} tabIndex="7"/>
                                                <label className="checkbox" htmlFor="chkSendVerifyEmail" tabIndex="7"></label>
                                                <label className="labeltext" htmlFor="chkSendVerifyEmail">{LBL_SEND_VERIFI_EMAIL}</label>
                                            </div>  
                                        </div></Col>}
                            </Row>
                            <div className="clearfix">
                                {/* <button disabled={isPrimaryContactSuccess===true} type="submit" className="btn btn-primary float-right">Save</button> */}
                                {!isSuperAdmin && <button type="submit" className="btn btn-primary float-right" tabIndex="8">{LBL_SAVE}</button>}
                            </div>
                        </div>
                    </div>
                
            </Form>
        </div>
        )
    }

}
export default PrimaryContact;